<template>
  <div id="main-wrapper">
    <div
      class="content-container profile-page personal-details request-call support-page open-tick"
    >
      <div class="page-wrap">
        
        <div class="page-content clearfix">
          <div class="main-content f-left">
            <div class="title-holder wow fadeInLeft">
              <h4>{{$t("open_ticket.heading")}}</h4>
            </div>
            <div class="support-nav wow fadeInLeft">
              <ul>
                <li><router-link to="/support">{{$t("open_ticket.create_request")}}</router-link></li>
                <li class="active">
                  <router-link to="/open-tickets">{{$t("open_ticket.open_tickets")}}</router-link>
                </li>
                <li>
                  <router-link to="/closed-tickets">{{$t("open_ticket.closed_ticket")}}</router-link>
                </li>
              </ul>
            </div>
            <div class="table-holder table-holder2 t-left">
              <table>
                <thead>
                  <tr>
                    <th>{{$t("open_ticket.ticket_number")}}</th>
                    <th>{{$t("open_ticket.trading_id")}}</th>
                    <th>{{$t("open_ticket.status")}}</th>
                    <th>{{$t("open_ticket.subject")}}</th>
                    <th>{{$t("open_ticket.created")}}</th>
                    <th>{{$t("open_ticket.action")}}</th>
                  </tr>
                </thead>
                <tbody
                  v-if="
                    store.openTickets.records &&
                    store.openTickets.records.length
                  "
                >
                  <tr
                    v-for="ticket of store.openTickets.records"
                    :key="ticket.id"
                  >
                    <td>{{ ticket.ticket }}</td>
                    <td>{{ ticket.account_id || '-' }}</td>
                    <td>{{ status_type[ticket.status] || '-' }}</td>
                    <td>
                      {{
                        store.ticketReasons[ticket.reason]
                          ? store.ticketReasons[ticket.reason].title
                          : "-"
                      }}
                    </td>
                    <td>{{ COMMON.formatDate(ticket.created) }}</td>
                    <td>
                      <button @click="goToTicketDetails(ticket.id)" class="btn btn-blue">
                        {{$t("open_ticket.view_ticket")}}
                      </button><br><br>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="5" class="t-center">{{$t("open_ticket.no_tickets_found")}}</td>
                  </tr>
                </tbody>
              </table>
              <pagination
                :totalRecords="store.openTickets.totalRecords"
                :pageNo="page"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { useMainStore } from "@/store";
import PaginationVue from "@/components/shared/Pagination";

export default {
  setup() {
    const store = useMainStore();
    return { store };
  },
  data() {
    return {
      page: 1,
      status_type: {'0':'Ticket Open','3':'Ticket Closed'}
    };
  },
  components: {
    pagination: PaginationVue,
  },
  mounted() {
    this.listing();
  },
  methods: {
    listing() {
      let formData = {
        filter: {},
        sort: [],
        search: "",
        page: this.page,
        perPage: this.static_vars.limitPerPage,
        status: "0",
      };
      this.store.getTicketsList(formData, true);
    },
    goToTicketDetails(id) {
      this.$router.push({ path: "ticket-details", query: { id } });
    },
    cancelticket(id){
      this.store.closeticket(id, true);
    }
  },
};
</script>
